export const EARLY_ACCESS_SOURCE = 'early_access';

export const earlyAccessBillingNotice = {
  heading: 'Billing is not active during Early Access',
  detail: 'Kubiqa is free for founding users. No credit card is required.',
};

export function isEarlyAccessRegistration(route = {}) {
  const params = route.params || {};
  const query = route.query || {};

  return !params.invitation && query.source === EARLY_ACCESS_SOURCE;
}

export function buildRegistrationPayload(fields, route) {
  const payload = { ...fields };

  if (isEarlyAccessRegistration(route)) {
    payload.signup_source = EARLY_ACCESS_SOURCE;
  }

  return payload;
}

export function trackSignupEvent(tracker, action, earlyAccess) {
  if (!tracker || typeof tracker.event !== 'function') {
    return false;
  }

  tracker.event('signup', action, earlyAccess ? EARLY_ACCESS_SOURCE : 'standard');
  return true;
}
